
import React from 'react';
import { InputContainer } from '../../../../../../../common/components/form/input/containers/input.container';


export const CompaignSmsRecipientInfoComponent = ({
  choosenEmailPlan,
  customerTags,
  handleInnerFormChange,
}: any) => {
 
  return (
    <>
     <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
     
<InputContainer
          label="Recipient" 
          labelField="displayText"
          list={customerTags}
          onValueChange={( newValue: any) => {
            const categoryData: any = newValue.map((option: any) => option?.value || '')
            handleInnerFormChange(
              categoryData,
              'RecipientTagIdInclusions',
            );
          }}
          type="multiselect"
          valueField="Id"
          value={choosenEmailPlan?.RecipientTagIdInclusions}
        />
      
      </div>
       
    </>
  );
};
export default CompaignSmsRecipientInfoComponent;
